import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form } from "formik";
import Grid from "@material-ui/core/Grid";
import { Button } from "@material-ui/core";
import LoadingButton from "../../shared-components/loading-button/LoadingButton";
import PageHeader from "../../shared-components/page-header/PageHeader";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { AppState } from "app/store";
import { createSubAgent } from "../store/create-subagent.slice";
import { resetSubAgentForm, setSubAgentForm } from "../store/subagent-form.slice";
import { subAgentInitialState } from "../store/subagent-form.slice";
// NEW subagent-only sections (no reuse from AgentEditPage)
import SubAgentInformation from "./components/SubAgentInformation";
import SubAgentReservation from "./components/SubAgentReservation";
import SubAgentCredits from "./components/SubAgentCredits";
import SubAgentProvision from "./components/SubAgentProvision";
import SubAgentDiscount from "./components/SubAgentDiscount";
import SubAgentDebt from "./components/SubAgentDebt";

const CreateSubAgentPage = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
const formInitial =
  useSelector((s: any) => s.agents?.subAgentForm) ?? subAgentInitialState();
  // subAgentForm initial state is EMPTY in your subagent-form.slice
//   const subAgentForm = useSelector((s: AppState) => (s as any).agents.subAgentForm);
//   const loading = useSelector((s: AppState) => (s as any).agents.createSubAgent.loading);
   const subAgentForm =
  useSelector((s: any) => s.agents?.subAgentForm) || subAgentInitialState;
  return (
    <div>
      <PageHeader
        title={t("app.main.agency.agentsList.subAgentCreate.title", "Create Sub-Agent")}
        desc={t("app.main.agency.agentsList.subAgentCreate.desc", "Fill the form below and click Save")}
        backButton={() => history.goBack()}
      />

      {/* <Formik
        enableReinitialize
        initialValues={subAgentForm}   // always a defined object now
        onSubmit={(values) => {
            dispatch(
            // @ts-ignore if you’re using raw Dispatch
            createSubAgent({ body: values }, () => {
                dispatch(resetSubAgentForm());
                history.push("../subAgents");
            })
            );
        }}
        > */}
              <Formik
        enableReinitialize
        initialValues={formInitial}
        onSubmit={(values, { resetForm }) => {
            // @ts-ignore (if you’re using plain Dispatch)
            dispatch(createSubAgent({ body: values }, () => {
            // 1) Reset Formik
            resetForm({ values: subAgentInitialState() });
            // 2) Reset Redux (keeps store clean if you revisit page)
            dispatch(resetSubAgentForm());
            // 3) Navigate if you want
            history.push("../subAgents");
            }));
        }}
        >
      
      
        <Form>
          <SubAgentInformation />
          <SubAgentReservation />
          <SubAgentCredits />
          <SubAgentProvision />
          <SubAgentDiscount />
          <SubAgentDebt />

          <Grid container justify="flex-end" style={{ marginTop: 20 }}>
            <Grid item>
              <LoadingButton
                type="submit"
                size="medium"
                // isLoading={loading}
                btnTitle={t("app.main.flights.flightList.editPage.saveChanges", "Save Changes")}
              />
              <Button onClick={() => history.goBack()}>
                {t("app.main.schedules.splitPassenger.closeButton", "Close")}
              </Button>
            </Grid>
          </Grid>
        </Form>
      </Formik>
    </div>
  );
};

export default CreateSubAgentPage;
